import { useEffect } from 'react';
import isOutOfViewport from '../helpers/isOutOfViewport';

/**
 * This hook takes will take in several Card refs and a map of panelToCard
 * If the selected Card goes out of viewport, it will scroll it back into view
 *
 * This scroll is bound to the right panel's transitionend Event
 * @param {String} selectedPanel
 * @param {Object} panelToCardMap: String=>React.ref
 */
const useScrollCardIntoView = (selectedPanel, panelToCardMap = {}) => {
  useEffect(
    () => {
      const cardRef = panelToCardMap[selectedPanel];

      const cardEl = cardRef?.current;
      const rightPanelEl = document.getElementsByClassName('side-panel')[0];

      if (!cardEl || !rightPanelEl) return () => {};

      const scrollTile = () => {
        if (isOutOfViewport(cardEl)) {
          cardEl.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest',
          });
        }
      };

      rightPanelEl.addEventListener('transitionend', scrollTile);

      return () =>
        rightPanelEl.removeEventListener('transitionend', scrollTile);
    },
    [selectedPanel]
  );
};

export default useScrollCardIntoView;
